import React, { useEffect, useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Typewriter from "typewriter-effect";

import {
  FaInstagram,
  FaLinkedin,
  FaDribbble,
  FaBehance,
  FaChevronCircleDown,
} from "react-icons/fa";
import { IconContext } from "react-icons/lib";

function Home() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closemobileMenu = () => setClick(false);

  const showButon = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };
  useEffect(() => {
    showButon();
  }, []);

  window.addEventListener("resize", showButon);

  return (
    <header id="home">
      <IconContext.Provider value={{ color: "#fff" }}>
        <nav id="nav-wrap">
          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
            Show navigation
          </a>
          <a className="mobile-btn" href="#home" title="Hide navigation">
            Hide navigation
          </a>

          <ul id="nav" className={click ? "nav_menu active" : "nav_menu"}>
            <li className="current">
              <a
                className="smoothscroll"
                href="#home"
                onClick={closemobileMenu}
              >
                Home
              </a>
            </li>

            <li>
              <a
                className="smoothscroll"
                href="#projects"
                onClick={closemobileMenu}
              >
                Projects
              </a>
            </li>

            <li>
              <a
                className="smoothscroll"
                href="#contact"
                onClick={closemobileMenu}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </IconContext.Provider>
      <div className="row banner">
        <div className="banner-text">
          <h1 className="responsive-headline">I'm Akib Sheikh.</h1>
          <h2>
            <Typewriter
              options={{
                strings: ["UI/UX Designer", "App Designer", "Devloper", "Web Designer", "Gamer",],
                autoStart: true,
                loop: true,
                delay: 50,
              }}
            />
          </h2>
          <h3>
            I'm a UI/UX Designer <span></span>. .
          </h3>
          <hr />
          <ul className="social_1">
            <div className="social_icons_1">
              <Link
                className="social_icon_link_1"
                to={"//www.behance.net/akibsheikh"}
                target="_blank"
                aria_label="Facebook"
              >
                <FaBehance />
              </Link>
              <Link
                className="social_icon_link_1"
                to={"//www.instagram.com/akibsheikh1/"}
                target="_blank"
                aria_label="Instagram"
              >
                <FaInstagram />
              </Link>
              <Link
                className="social_icon_link_1"
                to={"//dribbble.com/akibsheikh"}
                target="_blank"
                aria_label="DERRIBLE"
              >
                <FaDribbble />
              </Link>

              <Link
                className="social_icon_link_1"
                to="//www.linkedin.com/in/akib-sheikh-bb5a17190"
                target="_blank"
                aria_label="LinkedIn"
              >
                <FaLinkedin />
              </Link>
            </div>
          </ul>
        </div>
      </div>

      <p className="scrolldown">
        <a className="smoothscroll" href="#projects">
          <FaChevronCircleDown />
          <i className="icon-down-circle"></i>
        </a>
      </p>
    </header>
  );
}

export default Home;

// <IconContext.Provider value={{ color: "#fff" }}>
//   <div className="navbar">
//     <div className="navbar_container container">

//       <div className="menu_icon" onClick={handleClick}>
//         {click ? <FaTimes /> : <FaBars />}
//       </div>
//       <ul className={click ? "nav_menu active" : "nav_menu"}>
//         <li className="nav_item">
//           <Link to="/" className="nav_links" onClick={closemobileMenu}>
//             Home
//           </Link>
//         </li>
//         <li className="nav_item">
//           <Link
//             to="/services"
//             className="nav_links"
//             onClick={closemobileMenu}
//           >
//             About
//           </Link>
//         </li>
//         <li className="nav_item">
//           <Link
//             to="/products"
//             className="nav_links"
//             onClick={closemobileMenu}
//           >
//             Skill
//           </Link>
//         </li>
//         <li className="nav_item">
//           <Link
//             to="/products"
//             className="nav_links"
//             onClick={closemobileMenu}
//           >
//             Project
//           </Link>
//         </li>
//         <li className="nav_item">
//           <Link
//             to="/products"
//             className="nav_links"
//             onClick={closemobileMenu}
//           >
//             Contact
//           </Link>
//         </li>
//         <li className="nav_btn">
//         </li>
//       </ul>
//     </div>
//   </div>
// </IconContext.Provider>
